import React from "react";

//Small inline SVG icons (decorative - the link or button around them carries the label)

export const FacebookIcon = () => (
  <svg
    viewBox={"0 0 24 24"}
    aria-hidden={"true"}
    focusable={"false"}
  >
    <path
      fill={"currentColor"}
      d={"M13.5 21v-7.5h2.6l.4-3h-3V8.6c0-.9.3-1.5 1.5-1.5h1.6V4.4c-.3 0-1.2-.1-2.3-.1-2.3 0-3.9 1.4-3.9 4v2.2H7.8v3h2.6V21h3.1z"}
    />
  </svg>
);

export const InstagramIcon = () => (
  <svg
    viewBox={"0 0 24 24"}
    aria-hidden={"true"}
    focusable={"false"}
  >
    <path
      fill={"currentColor"}
      d={"M12 4.6c2.4 0 2.7 0 3.6.1 2.4.1 3.6 1.3 3.7 3.7.1.9.1 1.2.1 3.6s0 2.7-.1 3.6c-.1 2.4-1.3 3.6-3.7 3.7-.9.1-1.2.1-3.6.1s-2.7 0-3.6-.1c-2.4-.1-3.6-1.3-3.7-3.7-.1-.9-.1-1.2-.1-3.6s0-2.7.1-3.6c.1-2.4 1.3-3.6 3.7-3.7.9-.1 1.2-.1 3.6-.1zM12 3c-2.4 0-2.8 0-3.7.1-3.3.1-5.1 2-5.2 5.2C3 9.2 3 9.6 3 12s0 2.8.1 3.7c.1 3.3 2 5.1 5.2 5.2.9.1 1.3.1 3.7.1s2.8 0 3.7-.1c3.3-.1 5.1-2 5.2-5.2.1-.9.1-1.3.1-3.7s0-2.8-.1-3.7c-.1-3.3-2-5.1-5.2-5.2C14.8 3 14.4 3 12 3zm0 4.4a4.6 4.6 0 1 0 0 9.2 4.6 4.6 0 0 0 0-9.2zM12 15a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm4.8-8.9a1.1 1.1 0 1 0 0 2.2 1.1 1.1 0 0 0 0-2.2z"}
    />
  </svg>
);

export const WhatsAppIcon = () => (
  <svg
    viewBox={"0 0 32 32"}
    aria-hidden={"true"}
    focusable={"false"}
  >
    <path
      fill={"currentColor"}
      d={"M16 3C8.8 3 3 8.8 3 16c0 2.3.6 4.5 1.7 6.4L3 29l6.8-1.8c1.9 1 4 1.6 6.2 1.6 7.2 0 13-5.8 13-13S23.2 3 16 3zm0 23.6c-2 0-3.9-.5-5.5-1.5l-.4-.2-4 1.1 1.1-3.9-.3-.4a10.6 10.6 0 1 1 9.1 4.9zm5.8-7.9c-.3-.2-1.9-.9-2.2-1s-.5-.2-.7.2-.8 1-1 1.2-.4.2-.7.1a8.7 8.7 0 0 1-4.3-3.8c-.3-.6.3-.5.9-1.7.1-.2 0-.4 0-.5l-1-2.4c-.3-.6-.5-.5-.7-.5h-.6c-.2 0-.6.1-.9.4s-1.1 1.1-1.1 2.7 1.2 3.2 1.3 3.4c.2.2 2.3 3.5 5.6 4.9 2.1.9 2.9 1 3.9.8.6-.1 1.9-.8 2.2-1.5s.3-1.3.2-1.5c0-.2-.3-.3-.6-.4z"}
    />
  </svg>
);

export const ChevronIcon = ({ direction = "right" }) => (
  <svg
    viewBox={"0 0 20 36"}
    aria-hidden={"true"}
    focusable={"false"}
    style={direction === "left" ? { transform: "scaleX(-1)" } : undefined}
  >
    <path
      d={"M2 2l16 16L2 34"}
      fill={"none"}
      stroke={"currentColor"}
      strokeWidth={"1.6"}
    />
  </svg>
);

//Room amenity icons (Rooms page): shower, coffee station, bed
export const ShowerIcon = () => (
  <svg
    viewBox={"0 0 24 24"}
    aria-hidden={"true"}
    focusable={"false"}
  >
    <g
      fill={"none"}
      stroke={"currentColor"}
      strokeWidth={"1.3"}
    >
      <rect
        x={"4.5"}
        y={"2.5"}
        width={"15"}
        height={"19"}
      />
      <path d={"M15.5 2.5v19M17.5 11v2.5M6.5 5.5h4.5v2M8.5 7.5h5"} />
    </g>
    <g fill={"currentColor"}>
      <circle
        cx={"9"}
        cy={"10.5"}
        r={"0.7"}
      />
      <circle
        cx={"11.5"}
        cy={"10.5"}
        r={"0.7"}
      />
      <circle
        cx={"9"}
        cy={"13"}
        r={"0.7"}
      />
      <circle
        cx={"11.5"}
        cy={"13"}
        r={"0.7"}
      />
      <circle
        cx={"9"}
        cy={"15.5"}
        r={"0.7"}
      />
      <circle
        cx={"11.5"}
        cy={"15.5"}
        r={"0.7"}
      />
    </g>
  </svg>
);

export const CoffeeIcon = () => (
  <svg
    viewBox={"0 0 24 24"}
    aria-hidden={"true"}
    focusable={"false"}
  >
    <g
      fill={"none"}
      stroke={"currentColor"}
      strokeWidth={"1.3"}
      strokeLinecap={"round"}
    >
      <path d={"M5 11h11v1.5a5.5 5.5 0 0 1-11 0V11zM16 12h1.5a2 2 0 0 1 0 4H15"} />
      <path d={"M2.5 19.5c2 1.3 13.5 1.3 16 0"} />
      <path d={"M8 3.5c-1 1 1 2 0 3.5M10.5 3.5c-1 1 1 2 0 3.5M13 3.5c-1 1 1 2 0 3.5"} />
    </g>
  </svg>
);

export const BedIcon = () => (
  <svg
    viewBox={"0 0 24 24"}
    aria-hidden={"true"}
    focusable={"false"}
  >
    <g
      fill={"none"}
      stroke={"currentColor"}
      strokeWidth={"1.3"}
    >
      <path d={"M3 19v-9.5h18V19M3 16h18M4 9.5V5h16v4.5"} />
      <rect
        x={"6"}
        y={"6.8"}
        width={"5"}
        height={"2.7"}
        rx={"0.6"}
      />
      <rect
        x={"13"}
        y={"6.8"}
        width={"5"}
        height={"2.7"}
        rx={"0.6"}
      />
    </g>
  </svg>
);
